import { uploadImageToS3 } from '@/utils/imageUtils';

(function () {
    'use strict';
    'ngInject';
    angular.module('app.ctrls').controller('ImageDialogCtrl', imageDialogCtrl);

    function imageDialogCtrl(
        $scope,
        $mdDialog,
        $q,
        $timeout,
        $location,
        LibrariesAPIService,
        MultipleFileUploadService,
        ImageAPIService,
        blockUI,
        library,
        element,
        initialPosition,
        initialSort
    ) {
        $scope.element = element;
        $scope.imagePosition = initialPosition;
        $scope.imageSort = initialSort;
        $scope.categoryId = $location.search().categoryId;
        $scope.errorMessage = '';
        $scope.imagePath = '';
        $scope.thumbnailPath = '';
        $scope.filesToUpload = [];
        console.log('element', element, initialSort);

        // Set position if available. If element is not null we are in edit mode.
        if (element != null) {
            $scope.imagePosition = element.position;
            $scope.imagePath = element.Path;
            $scope.thumbnailPath = element.ThumbnailPath;
            $scope.categoryId = element.LibraryCategoryId;
            $scope.imageSort = element.Sort;
        }

        $scope.create = async function () {
            if (!$scope.filesToUpload.length && !$scope.imagePath) {
                return;
            }

            var uploadedImages = [];

            // Upload pending image files
            if ($scope.filesToUpload.length > 0) {
                // Upload each image to the server
                blockUI.start('Uploading image files 0%');
                uploadedImages = await MultipleFileUploadService.uploadDynamicImagesWithChunks(
                    $scope.filesToUpload,
                    4,
                    true,
                    function (progress) {
                        blockUI.message('Uploading image files ' + parseInt(progress) + '%');
                    }
                );
                blockUI.stop();
            } else {
                uploadedImages.push({
                    Path: $scope.imagePath,
                    ThumbnailPath: $scope.thumbnailPath
                });
            }

            // If element is not null we are in edit mode, update the element instead of creating it
            if (element === null) {
                // Save every uploaded image into the library, increment the position for each one starting from the current
                //  selected position.
                var position = $scope.imagePosition;
                var sort = $scope.imageSort;
                var promises = [];

                blockUI.start('Saving images(s) into library');
                uploadedImages.forEach((element) => {
                    (function (element, position, sort) {
                        const fileName = element.OriginalName ? element.OriginalName.split('.')[0] : $scope.fileName; // nameOfPicture.jpg -> nameOfPicture;
                        promises.push(
                            $q((resolve, reject) => {
                                LibrariesAPIService.addElement(
                                    library.LibraryId,
                                    position,
                                    {
                                        Path: element.Path,
                                        ThumbnailPath: element.ThumbnailPath,
                                        LibraryCategoryId: $scope.categoryId
                                    },
                                    'image',
                                    fileName,
                                    sort
                                )
                                    .then(function () {
                                        // New image added!
                                        resolve();
                                    })
                                    .catch(function (e) {
                                        blockUI.start('Saving images(s) into library');
                                        // If there's an element in this position already, update it
                                        if (e.status === 409) {
                                            // When only uploading a single image, don't allow overwriting existing positions
                                            if (uploadedImages.length === 1) {
                                                $scope.errorMessage =
                                                    "There's already an element at position " + position;
                                                reject();
                                            } else {
                                                console.log('Overwriting position ' + position);
                                                LibrariesAPIService.getLibraryElementAtPosition(
                                                    library.LibraryId,
                                                    position
                                                )
                                                    .then(function (image) {
                                                        // Update the element that already exists
                                                        image.Path = element.Path;
                                                        image.ThumbnailPath = element.ThumbnailPath;
                                                        image.LibraryCategoryId = $scope.categoryId;
                                                        image.name = fileName;

                                                        LibrariesAPIService.updateElement(
                                                            library.LibraryId,
                                                            image.ImageId,
                                                            image,
                                                            'image'
                                                        )
                                                            .then(function () {
                                                                resolve();
                                                            })
                                                            .catch(function (e) {
                                                                reject(e);
                                                            });
                                                    })
                                                    .catch(function (e) {
                                                        reject(e);
                                                    });
                                            }
                                        } else {
                                            reject(e);
                                        }
                                    });
                            })
                        );
                    })(element, position++, sort++);
                });

                // Wait for all the elements to be added
                $q.all(promises)
                    .then(function () {
                        blockUI.reset();
                        $mdDialog.hide();
                    })
                    .catch(function () {
                        blockUI.reset();
                    });
            } else {
                // Update image
                element.Path = $scope.imagePath;
                element.ThumbnailPath = $scope.thumbnailPath;
                element.LibraryCategoryId = $scope.categoryId;

                element.Name = $scope.fileName; // nameOfPicture.jpg -> nameOfPicture
                LibrariesAPIService.updateElement(library.LibraryId, element.ImageId, element, 'image')
                    .then(function () {
                        // Image updated!
                        $mdDialog.hide();
                    })
                    .catch(function (e) {
                        console.error(e);
                        $scope.errorMessage = 'Error updating image!';
                    });
            }
        };

        $scope.uploadImage = async function (event) {
            const files = event.target.files;
            if (files && files[0]) {
                try {
                    // If we are uploading more than one file don't upload the images now as we can't preview multiple
                    //  image files in a small dialog (we also don't want to upload many image files for no reason to the
                    //  server) so just save the files and upload them later.
                    // Also we don't support uploading multiple files when in edit mode (element is not null).
                    if (files.length > 1 && !element) {
                        $scope.filesToUpload = files;
                        $scope.svgPath = '';
                        return;
                    }
                    $scope.filesToUpload = [];
                    $scope.errorMessage = '';

                    // Upload image to S3 and generate a thumbnail from it
                    blockUI.start('Uploading Image');
                    const response = await uploadImageToS3('preview', files[0], function (progress) {
                        blockUI.message(`Uploading Image ${parseInt(progress)}%`);
                    });
                    const thumbResponse = await ImageAPIService.generateImageThumbnail(response.Name);
                    console.log('Success on image upload!');
                    $scope.imagePath = response.Path;
                    $scope.thumbnailPath = thumbResponse.Path;
                    $scope.fileName = files[0].name.split('.')[0]; // nameOfPicture.jpg -> nameOfPicture

                    blockUI.stop();
                    $timeout(() => $scope.$apply());
                } catch (error) {
                    console.error(error);
                    $scope.errorMessage = 'Error uploading image';
                    blockUI.stop();
                    $timeout(() => $scope.$apply());
                }
            }
        };

        $scope.cancel = function () {
            $mdDialog.cancel();
        };
    }
})();
